import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { KeyRound, Sparkles } from "lucide-react";
import { PageHeader } from "@/components/PageHeader";
import { Button } from "@/components/ui/Button";
import { useApiKeysQuery } from "@/features/apikeys/hooks/useApiKeys";
import { useBillingStatusQuery } from "@/features/billing/hooks/useBilling";
import { useAuthStore } from "@/stores/authStore";

export function HomePage() {
  const { t } = useTranslation();
  const account = useAuthStore((s) => s.account);
  const { data: apiKeys } = useApiKeysQuery();
  const { data: billingStatus } = useBillingStatusQuery();
  const activeApiKeys = apiKeys?.filter((key) => !key.revoked).length;
  const isNewAccount = apiKeys !== undefined && activeApiKeys === 0;

  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={t("home.title")}
        subtitle={t("home.welcome", { email: account?.email ?? "" })}
      />
      <div className="grid gap-4 sm:grid-cols-2">
        <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
          <p className="text-sm text-muted-foreground">{t("home.planLabel")}</p>
          <p className="mt-1 text-lg font-medium">
            {billingStatus
              ? billingStatus.plan === "PAID"
                ? t("plan.PAID")
                : t("plan.FREE")
              : t("common.dash")}
          </p>
        </div>
        <div className="rounded-xl border border-border bg-card p-4 shadow-sm">
          <p className="text-sm text-muted-foreground">{t("home.activeApiKeys")}</p>
          <p className="mt-1 text-lg font-medium">{activeApiKeys ?? t("common.dash")}</p>
        </div>
      </div>
      {isNewAccount ? (
        <div className="flex flex-col items-start gap-3 rounded-xl border border-primary/30 bg-primary/5 p-5">
          <Sparkles className="size-5 text-primary" />
          <div>
            <p className="font-medium text-foreground">{t("home.gettingStarted.title")}</p>
            <p className="mt-1 text-sm text-muted-foreground">
              {t("home.gettingStarted.description")}
            </p>
          </div>
          <Button render={<Link to="/api-keys" />}>
            <KeyRound />
            {t("home.gettingStarted.action")}
          </Button>
        </div>
      ) : (
        <Button variant="outline" className="w-fit" render={<Link to="/api-keys" />}>
          <KeyRound />
          {t("home.manageApiKeys")}
        </Button>
      )}
    </div>
  );
}
